import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-recon-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-workday-invoice.component.html',
  styleUrl: './view-workday-invoice.component.css'
})
export class ViewWorkdayInvoiceComponent {

}
